import { Box, Table, Text } from "@chakra-ui/react";
import { formatDate } from "@/utils/formatDate";
import { ErpProduct } from "@/shared/core-products";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

interface ErpProductAdjustmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  erpProduct: ErpProduct;
}

const headerProps = {
  fontSize: "xs",
  fontWeight: "semibold",
  letterSpacing: "wider",
  textTransform: "uppercase",
  color: "fg.muted",
} as const;

const ErpProductAdjustmentsModal = ({
  isOpen,
  onClose,
  erpProduct,
}: ErpProductAdjustmentsModalProps) => {
  const {
    product: { productAdjustments, ...product },
  } = erpProduct;
  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="flex-start"
          pe={12}
          borderBottomWidth="1px"
          borderColor="border"
        >
          <Box>
            <DialogTitle>Detalles de reajustes</DialogTitle>
            <Text color="fg.muted" fontSize="sm" fontWeight="normal" mt={1}>
              {product.description}
            </Text>
          </Box>
          <Box textAlign="end">
            <Text color="fg.muted" fontSize="xs" textTransform="uppercase">
              Stock actual
            </Text>
            <Text fontWeight="bold" fontSize="lg">
              {product.stock}
            </Text>
          </Box>
        </DialogHeader>
        <DialogBody pt={4}>
          <Box borderWidth="1px" borderColor="border" rounded="lg">
            <Table.Root size="sm" variant="line">
              <Table.Header bg="bg.subtle">
                <Table.Row>
                  <Table.ColumnHeader {...headerProps}>
                    Fecha
                  </Table.ColumnHeader>
                  <Table.ColumnHeader {...headerProps}>
                    Motivo
                  </Table.ColumnHeader>
                  <Table.ColumnHeader {...headerProps} textAlign="end">
                    Ajuste
                  </Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {productAdjustments?.map((productAdjustment, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>
                      {formatDate(productAdjustment.createdAt)}
                    </Table.Cell>
                    <Table.Cell>
                      {productAdjustment.productAdjustmentType?.name}
                    </Table.Cell>
                    <Table.Cell textAlign="end" fontWeight="semibold">
                      {productAdjustment.adjustmentProduct?.quantity}
                    </Table.Cell>
                  </Table.Row>
                ))}
                {!productAdjustments?.length && (
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      textAlign="center"
                      py={8}
                      color="fg.muted"
                    >
                      No hay detalles de reajustes disponibles
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table.Root>
          </Box>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

export default ErpProductAdjustmentsModal;
